import { useEffect } from 'react';

import { useNewFeatureAlertModal } from '@/modals';

import { useUser } from '@/entities/user/model/user.store';

import {
  getCloudStorageValue,
  setCloudStorageValue,
} from '@/shared/helpers/cloud-storage';
import { useFeatureFlag } from '@/shared/hooks/use-feature-flag';

const STORAGE_KEY = 'viewed_new_feature_alert_version';

export const useNewFeatureAlert = () => {
  const { isKassir } = useFeatureFlag();

  const { open } = useNewFeatureAlertModal();

  const user = useUser();

  useEffect(() => {
    // TODO: Remove flag after testing
    if (!isKassir) return;

    if (!user || user.tests.isNew) return;

    const newFeatureAlert = user.newFeatureAlert;

    if (!newFeatureAlert?.isModalVisible) return;

    void (async () => {
      const viewedVersion = await getCloudStorageValue(STORAGE_KEY);

      if (viewedVersion === null || +viewedVersion < newFeatureAlert.version) {
        open({
          ...newFeatureAlert,
          onClose: () =>
            void setCloudStorageValue(STORAGE_KEY, newFeatureAlert.version.toString()),
        });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [!!user]);
};
